<p  class="type-room-select mb-0 mt-2" style="background-color: #d5f9ed; border-radius: 50px; width: 100px; height:20px; text-align: center; padding: 2px; color: #5bca90; margin: 2px; text-transform: capitalize;">{{stringUpperCase(item.transferType)}}</p>

                        <div class="d-flex flex-column detail-item" [ngStyle]="{'width': item.categoryName === 'TRANSPORTS'  ? '' : 'calc(100% - -25px)'}">


                            <div *ngIf="item.categoryName == 'TRANSPORTS'" class="hotel-date font-poppins m-0">
                              <p class="mb-0 mt-3" [ngStyle]="{ color: styleSidebar?.color }">
                                <strong class="font-verde" style="text-transform: capitalize;">Pick up: </strong>
                                <span style="text-transform: capitalize;"> {{ extractNameTransport(item, "origin")}}</span>
                              </p>
                            </div>
                            <div *ngIf="item.categoryName == 'TRANSPORTS'" class="hotel-date font-poppins m-0">
                              <p class="mb-0 mt-2" [ngStyle]="{ color: styleSidebar?.color }">
                                <strong class="font-verde" style="text-transform: capitalize;">Drop off: </strong>
                                <span style="text-transform: capitalize;">{{ extractNameTransport(item, "destination") }}</span>
                              </p>
                            </div>


                            <div *ngIf="item.categoryName == 'TRANSPORTS'" class="hotel-date font-poppins m-0 mb-1">
                              <p class="mb-0 mt-3" style="text-transform: capitalize;" [ngStyle]="{ color: styleSidebar?.color }">
                                <strong class="font-verde" style="text-transform: capitalize;">Inicio: </strong>{{ item?.arrivalDate | date : "dd/MMM/yyyy" }} ({{
                                  item?.payload[0].transfers.pickupTime
                                }}
                                hs. - {{ getMessageFirstTime("origin", item?.payload[0].transfers.pickupLocation) }})
                              </p>
                            </div>

                            <div
                              class="d-flex"
                              style="color: #939295; width: max-content"
                              [ngClass]="{ 'justify-content-center': item?.categoryName == 'TOURS' }"
                            >

                                <span
                                *ngIf="item?.categoryName == 'TRANSPORTS'"
                                class="hotel-room m-0 mt-1"
                                style="
                                  font-family: 'Rubik', serif;
                                  text-transform: lowercase;
                                  display: flex;
                                  align-items: center;
                                  width: 100%;
                                "
                              >
                              <p class="mb-0 ml-2 mr-1" style="font-family: 'poppins'; font-size: 15px; font-weight: 500"
                              [ngStyle]="{ color: styleSidebar?.color }">
                              {{  item?.paxAdults + item?.paxChildren }}
                              </p>
                                <img
                                  src="../../../assets/icons/search-result/persona.svg"
                                  width="25px"
                                  height="25px"
                                  alt=""
                                />
                              </span>
                              <span
                                *ngIf="item?.categoryName == 'TRANSPORTS'"
                                class="hotel-room m-0 mt-1"
                                style="
                                  font-family: 'Rubik', serif;
                                  text-transform: lowercase;
                                  display: flex;
                                  align-items: center;
                                  width: 100%;
                                "
                              >
                              <p class="mb-0 ml-2 mr-2" style="font-family: 'poppins'; font-size: 15px; font-weight: 500"
                              [ngStyle]="{ color: styleSidebar?.color }">
                              {{ item.vehicle?.bag?.numberLargeSuitcases  }}
                              </p>
                                <img
                                  src="../../../assets/icons/search-result/maleta.svg"
                                  width="25px"
                                  height="25px"
                                  alt=""
                                />
                              </span>
                               <span
                                *ngIf="item?.categoryName == 'TRANSPORTS'"
                                class="hotel-room m-0 mt-1"
                                style="
                                  font-family: 'Rubik', serif;
                                  text-transform: lowercase;
                                  display: flex;
                                  align-items: center;
                                  width: 100%;
                                "
                              >
                              <p class="mb-0 ml-2 mr-1" style="font-family: 'poppins'; font-size: 15px; font-weight: 500"
                              [ngStyle]="{ color: styleSidebar?.color }">
                              {{ getBagsHands(item.vehicle?.bag) }}
                              </p>
                                <img
                                  src="../../../assets/icons/search-result/carry.svg"
                                  width="25px"
                                  height="25px"
                                  alt=""
                                />
                              </span>


                            </div>
                        </div>
